import Seller from "./From/Seller";
import Source from "./From/Source";
import Target from "./To/Target";
import Shipping from "./Shipping";
import Notenum from "./Shipping/Notenum";
import Comment from "./Comment";
import React, {Fragment} from "react";
import BoxEditor from "../../BoxEditor";
import Buttons from "../Elements/Buttons";
import List from "./List";
import PoolList from "./Picking/PoolList";
import Other from "./Other";
import AccountDate from "./Invoice/Dates/AccountDate";

export default (componentProps) => {
    const {props, state, parent} = componentProps;
    const {hidden, labels, actionButtons} = props;
    const Editor = props.editor || BoxEditor;
    return <Fragment>
        <List boxid={props.componentEditor + "ListBox"} {...componentProps} />
        <Editor
            theme="default"
            footer={<Fragment>
                <Buttons {...componentProps} />
            </Fragment>}
        >
            {
                props.values.id && <form onSubmit={props.handleSubmit}>
                    <Other {...componentProps} tag={Fragment} />
                    <div className="row form-row">
                        <div className="col-md-3">
                            <Seller {...componentProps} />
                        </div>
                        <div className="col-md-3">
                            <Source {...componentProps} />
                        </div>
                        <div className="col-md-3">
                            <Target {...componentProps} />
                        </div>
                        <AccountDate
                            col="3"
                            {...componentProps}
                            isClearable={true}
                        />
                    </div>
                    <div className="row form-row">
                        <Shipping {...componentProps} />
                        {/*<Notenum {...componentProps} />*/}
                    </div>
                    <Comment {...componentProps} />
                    <PoolList {...componentProps} control={{visible: false}}/>
                </form>
            }
        </Editor>
    </Fragment>;
}